//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getWorkOrderOperationLogs} from '../../../../api/workOrder';
import fileUploader from '@/views/common-components/file-uploader';
import {OperationType} from '@/views/service/workOrder/workOrderEnum'

export default {
  name: 'workOrder-operation-log',
  components: {
    fileUploader
  },
  props: {
    workOrderId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      operationLogs: [],
      OperationType
    };
  },
  methods: {
    getOperationLogs() {
      const vm = this;
      getWorkOrderOperationLogs(this.workOrderId).then((res) => {
        vm.operationLogs = [];
        vm.operationLogs.push(...res.data.result);
      }).finally(() => {

      });
    }
  },
  created() {
    this.getOperationLogs();
  },
  watch: {
    workOrderId() {
      this.getOperationLogs();
    }
  }
};
